var map = {
	"./B.svg": 9258,
	"./K.svg": 6849,
	"./N.svg": 633,
	"./P.svg": 7627,
	"./Q.svg": 1209,
	"./R.svg": 1953,
	"./_B.svg": 2689,
	"./_K.svg": 2749,
	"./_N.svg": 5231,
	"./_P.svg": 9831,
	"./_Q.svg": 8770,
	"./_R.svg": 5746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8850;